import { connect } from 'react-redux';

import { changeRouteByLanguage } from 'actions/i18n';

import LanguageButton from './component';

const mapStateToProps = ({ i18n: { lan } }) => ({
	lan,
});

const mapDispatchToProps = dispatch => ({
	select: targetLanguage => dispatch(changeRouteByLanguage(targetLanguage)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LanguageButton);



// WEBPACK FOOTER //
// ./src/components/atoms/LanguageButton/index.js